module.exports = __webpack_public_path__ + "static/media/Matt Maple Headshot_1685546936285.c55cab22.jpeg";